"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 15v2H5v-2zm2-10H3v2h18zm0 4H3v2h18zm0 4H3v6h18z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5 15h14v2H5z",
  opacity: ".3"
}, "1")], 'HorizontalSplitTwoTone');